<template>
  <section>
    <b-modal
      ref='modalTabVideos'
      id='modalTabVideos'
      hide-footer
      :hide-header="!instructionalVideos || instructionalVideos.length <= 0"
      header-bg-variant='info'
      header-text-variant='light'
      size='lg'
      scrollable
      :no-close-on-esc="closeModalTabVideos"
      :no-close-on-backdrop="closeModalTabVideos"
      :hide-header-close="closeModalTabVideos"
      :title="`${instructionalVideos && instructionalVideos.length > 0 ? instructionalVideos[slide].title : '-'}`"
      @show='showModal()'
      @hidden='hiddenModal()'
    >
      <b-overlay
        :show="loadingOverlay"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
        style="min-height: 100px"
      >
        <section class='modal-font-family modal-tab-videos'>
          <p v-if="closeModalTabVideos" class='text-right'>Você poderá fechar esse modal em <strong>{{ time }}
            segundos</strong></p>
          <section>
            <b-carousel
              id="carousel"
              ref="carousel"
              v-model="slide"
              background="#ababab"
              img-width="1024"
              img-height="480"
              :interval="4000"
              style="text-shadow: 1px 1px 2px #333;"
              @sliding-start="onSlideStart"
              @sliding-end="onSlideEnd"
            >
              <b-carousel-slide
                img-blank
                img-blank-color="#000"
                v-for="(instructionalVideo, index) in instructionalVideos"
                :key="instructionalVideo._id"
              >
                <template #img>
                  <section class="w-100">
                    <iframe
                      width="100%"
                      height="500"
                      :src="`https://www.youtube.com/embed/${getYoutubeId(instructionalVideo.videoLink)}`"
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </section>
                </template>
              </b-carousel-slide>
            </b-carousel>
          </section>

          <section class="d-flex justify-content-center align-items-center mt-3"
                   v-if="instructionalVideos && instructionalVideos.length > 0">
            <button @click="prev()" class="btn">
              <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="20" y="20" width="20" height="20" rx="10" transform="rotate(-180 20 20)" fill="#022245" />
                <path d="M13.5 4.67529L13.5 14.6753L5.5 9.67529L13.5 4.67529Z" fill="#ECF0F3" />
              </svg>
            </button>
            <section class="controls d-flex justify-content-center">
              <section
                class="cursor-pointer mx-1"
                v-for="(instructionalVideo, index) in instructionalVideos"
                :key="`${instructionalVideo._id}_${index}`"
                :class="index == slide ? 'slide-current' : 'slides-hidden'"
                @click="setSlide(index)"
              >

              </section>
            </section>

            <button @click="next()" class="btn">
              <svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="20" height="20" rx="10" fill="#022245" />
                <path d="M6.5 15.3247L6.5 5.32471L14.5 10.3247L6.5 15.3247Z" fill="#ECF0F3" />
              </svg>
            </button>
          </section>

          <section v-if="instructionalVideos && instructionalVideos.length > 0">
            <p class="title-description mb-1">
              Descrição do vídeo
            </p>
            <p class="description">{{ instructionalVideos[slide].description }}</p>
          </section>

          <section v-if="showBtn" class="d-flex justify-content-between mt-4">
            <b-overlay
              :show="loading"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              class="d-inline-block w-100"

            >
              <base-button
                class="w-100 btn-add d-flex align-items-center justify-content-center"
                @click="closeModalInstructionalVideos()"
              >
                <span>Prosseguir</span>
              </base-button>
            </b-overlay>
          </section>
        </section>
        <template v-slot:overlay>
          <div class="text-center loading-spinner">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Large Spinner"
            ></b-spinner>
            <h5 class="text-primary">Buscando...</h5>
          </div>
        </template>
      </b-overlay>
    </b-modal>
  </section>
</template>
<script>
import { mapActions } from 'vuex'
import moment from 'moment/moment'

export default {
  name: 'ModalTabVideos',
  data() {
    return {
      loadingOverlay: false,
      closeModalTabVideos: true,
      showBtn: false,
      loading: false,
      slide: 0,
      sliding: null,
      interval: null,
      timeout: null,
      start: null,
      end: null
    }
  },
  props: {
    instructionalVideos: { type: Array, required: true, default: Array },
    timer: { type: Boolean, required: false, default: false }
  },
  computed: {
    errors() {
      return this.$store.getters['access/error']
    },
    tabView() {
      return this.$store.getters['legalSearch/tabView']
    },
    time() {
      return this.start ? moment(this.start).format('mm:ss') : ''
    },
    user() {
      return this.$store.getters['user/current']
    },
  },
  methods: {
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),
    ...mapActions('instructionalVideo', {
      handleUpdateViewed: 'handleUpdateViewed',
    }),
    ...mapActions('access', {
      updateModalTabVideosBeingShown: 'updateModalTabVideosBeingShown',
    }),

    onSlideStart(slide) {
      this.sliding = true
    },

    onSlideEnd(slide) {
      this.sliding = false
    },
    setSlide(slide) {
      this.$refs.carousel.setSlide(slide)
    },
    prev() {
      this.$refs.carousel.prev()
    },
    next() {
      this.$refs.carousel.next()
    },

    startTimer() {
      this.start = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), new Date().getHours(), 0, 10)
      this.end = moment(this.start).add(-10, 'seconds').toDate()

      this.interval = setInterval(() => {
        if (moment(this.start).isAfter(moment(this.end))) {
          this.start = moment(this.start).add(-1, 'seconds').toDate()
        }
      }, 1000)
    },
    init(){
      this.showModal()
      setTimeout(() => {
        this.$refs['modalTabVideos'].show()
      }, 100)
    },
    async showModal() {
      this.closeModalTabVideos = false;
      if (this.timer) {
        await this.handleUpdateViewed(this.user.id)
        this.closeModalTabVideos = true;
        clearInterval(this.interval)
        clearTimeout(this.timeout)
        this.startTimer()
        this.timeout = setTimeout(async () => {
          this.showBtn = true
          if (this.closeModalTabVideos) {
            await this.handleUpdateViewed(this.user.id)
          }
          this.closeModalTabVideos = false
        }, 10000)
      } else {
        this.showBtn = true
      }
      await this.updateModalTabVideosBeingShown(true)
    },
    async hiddenModal() {
      clearInterval(this.interval)
      clearTimeout(this.timeout)
      await this.updateModalTabVideosBeingShown(false)
    },

    getYoutubeId(url) {
      const { hostname, pathname, searchParams } = new URL(url);
      if (hostname.includes('youtu.be')) {
        return pathname.slice(1);
      }

      if (pathname.includes('/shorts/')) {
        return pathname.split('/shorts/')[1];
      }

      return searchParams.get('v');
    },

    closeModalInstructionalVideos() {
      this.$bvModal.hide('modalTabVideos')
    }
  },
  watch: {}
}
</script>
<style lang="scss" scoped>
.modal-tab-videos {
  .controls {
    .slide-current {
      background: #04A8F366;
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }

    .slides-hidden {
      background: #D9D9D9;
      width: 25px;
      height: 25px;
      border-radius: 50%;
    }

    .btn {
      border: none;
    }
  }

  .title-description {
    font-weight: 700;
    font-size: 16px;
    color: #262626;
  }

  .description {
    font-weight: 400;
    font-size: 15px;
    color: #808080;
  }

  .btn-cancel {
    background: transparent !important;
    border-radius: 6.25px !important;
    border: 1px solid var(--navy-blue) !important;

    span {
      color: var(--navy-blue);
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
    }
  }

  .btn-add {
    background: var(--navy-blue) !important;
    border-radius: 6.25px !important;
    border: 1px solid var(--navy-blue) !important;

    span {
      color: #ffffff;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
    }
  }
}

</style>